import * as SwitchPrimitive from "@radix-ui/react-switch";
import { cn } from "./_utils";

/**
 * Switch toggle built on Radix Switch.
 *
 * @example
 * <Switch checked={enabled} onCheckedChange={setEnabled} />
 */
export function Switch({
  className,
  ...props
}: React.ComponentProps<typeof SwitchPrimitive.Root>) {
  return (
    <SwitchPrimitive.Root
      className={cn(
        "peer inline-flex h-5 w-9 shrink-0 cursor-pointer items-center " +
          "rounded-[var(--radius-pill)] border-2 border-transparent transition-colors " +
          "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-border-focus " +
          "disabled:cursor-not-allowed disabled:opacity-50 " +
          "data-[state=checked]:bg-accent data-[state=unchecked]:bg-border-hover",
        className
      )}
      {...props}
    >
      <SwitchPrimitive.Thumb
        className={cn(
          "pointer-events-none block h-4 w-4 rounded-[var(--radius-pill)] bg-bg-input shadow-[var(--shadow-xs)] " +
            "transition-transform " +
            "data-[state=checked]:translate-x-4 data-[state=unchecked]:translate-x-0"
        )}
      />
    </SwitchPrimitive.Root>
  );
}
